import apiv2 from '../http-common/http-common-apiv2'

class APIv2{
    autenticarUsuario (data){
        return apiv2.post("/usuario/autenticar", data)
    }

    historicoVistoria (idVistoria){
        return apiv2.get("/vistoria/logs/" + idVistoria)
    }
}

export default new APIv2()